const basePath = config.VUE_APP_BASE_URL || process.env.VUE_APP_BASE_URL;

export const routes = {
  appRoutes: {
    devices: {
      url: '/devices/devices-list'
    },
    devicesList: {
      url: '/devices/devices-list'
    },
    /*
    dashboard: {
      url: '/devices/dashboard'
    },
    */
    compatibilityChecker: {
      url: '/checker'
    },
    devicesHistory: {
      url: '/devices/history'
    },
    personalisationList: {
      url: '/devices/personalisation'
    },
    tollDomainsOverview: {
      url: '/tolling/overview'
    },
    tollDomainsRules: {
      url: '/tolling/rules'
    },
    tollDomainsDAT: {
      url: '/tolling/dat'
    },
    tollDomainsInstance: {
      url: '/tolling/instance'
    },
    userManagementList: {
      url: '/access-management/user-list'
    },
    userManagementRole: {
      url: '/access-management/user-role'
    },
    permissionsErrors: {
      url: '/permissions-error'
    }
  },
  apiRoutes: {
    basePath
  }
};

export const routesLabels: { [key: string]: string } = {
  'compatibility-checker': 'checker.compatibility',
  'devices-list': 'device.list.title',
  'history': 'device.history.title',
  'access-management': 'access.management',
  'user-list': 'access.user.list',
  'user-role': 'access.user.role',
  'user-group': 'access.user.group',
  'permissions-errors': 'common.error.permissions_denied.header',
  'overview': 'map.tolldomains.overview.title',
  'add': 'map.tolldomains.overview.breadcrumb-add',
  'rules': 'map.tolldomains.rules',
  'create': 'map.tolldomains.rules-breadcrumb-create',
  'update': 'map.tolldomains.rules-breadcrumb-update',
  'dat': 'map.tolldomains.dat',
  'instance': 'map.tolldomains.instance',
  'dashboard': 'dashboard.title',
  'personalisation': 'device.personalisation.title'
};

export const topicsLabels: { [key: string]: string } = {
  'checker': 'checker.compatibility',
  'devices': 'device.management',
  'tolling': 'map.tolling',
  'access-management': 'access.management',
  'user-list': 'access.user.list',
  'user-role': 'access.user.role',
  'user-group': 'access.user.group',
  'permissions-errors': 'error.permissions_denied',
  'dashboard': 'dashboard.title'
};

export const breadcrumbRoutes: { [key: string]: string } = {
  'compatibility-checker': routes.appRoutes.compatibilityChecker.url,
  'devices-list': routes.appRoutes.devicesList.url,
  'history': routes.appRoutes.devicesHistory.url,
  'overview': routes.appRoutes.tollDomainsOverview.url,
  'rules': routes.appRoutes.tollDomainsRules.url,
  'dat': routes.appRoutes.tollDomainsDAT.url,
  'instance': routes.appRoutes.tollDomainsInstance.url
};

export default routes;
